import CD_SectionOne from "./CD_SectionOne";

function CreateProducts() {
  return (
    <>
      <main>
        <CD_SectionOne />
      </main>
    </>
  );
}

export default CreateProducts;
